<template>
    <b-dropdown
        ref="dropdown"
        class="multiselect"
        variant="default"
    >
        <template #button-content>
            <div
                @click="onInputFocus()"
            >
                {{ label }}
            </div>
        </template>
        <div class="p-2 pt-2 pb-1" v-if="showSearchInput || showSelectAllButton">
            <b-form-input
                v-if="showSearchInput"
                v-model="keyword"
                ref="input"
                @keydown="onKeydown"
                @input="onInput($event)"
                size="sm"
            ></b-form-input>
            <b-button
                v-if="showSelectAllButton"
                @click="onSelectAll()"
                size="sm"
                variant="default"
                class="mt-2 w-100"
            >
                {{ defaultLabel }}
            </b-button>
        </div>
        <li
            v-for="(option, i) in headerOptions"
            :key="(i + mutableOptions.length)"
            :class="{
                'active': arrowCounter == (i + mutableOptions.length),
                'selected': selecteds[option[valueKey]]
            }"
            :ref="'option_' + (i + mutableOptions.length)"
        >
        <a 
                v-if="!option.disabled"
                href="#"
                @click.prevent="onSelect()"
                @mouseover="setArrowCounter(i + mutableOptions.length)"
                :class="option.class"
            >
                {{ option.text }}
            </a>
            <a
                v-if="option.disabled" 
                class="disabled"
                :class="option.class"
            >
                {{ option.text }}
            </a>
        </li>
        <li
            v-for="(option, i) in mutableOptions"
            :key="i"
            :class="{
                'active': arrowCounter == i,
                'selected': selecteds[option[valueKey]]
            }"
            :ref="'option_' + i"
        >
            <strong class="ml-2" v-if="option.groupTitle">{{ option.groupTitle }}</strong>
            <a 
                v-if="!option.disabled"
                href="#"
                @click.prevent="onSelect()"
                @mouseover="setArrowCounter(i)"
                :class="option.class"
            >
                <span v-if="option.child" class="ml-3">{{ option.text }}</span>
                <span v-else>{{ option.text }}</span>
            </a>
            <a
                v-if="option.disabled" 
                class="disabled"
                :class="option.class"
            >
                {{ option.text }}
            </a>
            <hr class="m-0 p-0 mt-1" v-if="option.divider" />
        </li>
    </b-dropdown>  
</template>
<script>
export default {
    props: {
        value: {
            default: () => [],
        },
         showSearchInput: {
            type: Boolean,
            default: true,
        },
        showSelectAllButton: {
            type: Boolean,
            default: true,
        },
        defaultLabel: {
            type: String,
            default: 'Todos',
        },
        headerOptions: {
            type: Array,
            default: () => []
        },
        options: {
            type: Array,
            default: () => [],
        },
        valueKey: {
            type: String,
            default: 'value',
        },
        textKey: {
            type: String,
            default: 'text',
        },
        onlySelectRules: {
            default: () => [],
            type: Array
        },
        enableSelectionAll:{
            type: Boolean,
            default: true,
        }
    },
    computed: {
        label: function(){
            let label = ''
            const selecteds = Object.keys(this.selecteds)
            if(selecteds.length){
                selecteds.map((x, y) => {
                    if(y > 0){
                       label += ', ' 
                    }
                    label += this.selecteds[x].text
                })
            }else{
                label = this.defaultLabel 
            }
            return label
        }
    },
    watch: {
        value() {
            this.loadDefaultOptions()
        },
    },
    data(){
        return {
            keyword: '',
            arrowCounter: 0,
            mutableOptions: [],
            selecteds: {},
        }
    },
    mounted() {
        this.$root.$on('bv::dropdown::hide', () => {
            this.keyword = '';
            this.cloneOptions()
        })
    },
    created() {
        this.loadDefaultOptions()
        this.cloneOptions()
    },
    methods: {
        loadDefaultOptions(){
            if(this.value.length){
                this.value.map(dOption => {
                    this.options.map(option => {
                        if(option[this.valueKey] == dOption){
                            this.$set(
                                this.selecteds, 
                                dOption, 
                                option
                            )
                        }
                    })
                })
            }else{
                this.selecteds = {}
            }
        },
        onInputFocus(){
            setTimeout(() => {
                this.$refs.input.focus()
            }, 100)
        },
        onKeydown(event){
            switch (event.code) {
                case 'ArrowDown':
                    event.preventDefault()
                    this.onArrowDown()
                    break
                case 'ArrowUp':
                    event.preventDefault()
                    this.onArrowUp()
                    break
                case 'Enter':
                    event.preventDefault()
                    this.onSelect()
                    break
                case 'Escape':
                    this.onBlur()
                    break
            }
        },
        onInput(value){
            this.keyword = value
            this.searchInternally()
        },
        emitInput() {
            this.$emit('input', Object.keys(this.selecteds))
            this.$emit('change', Object.keys(this.selecteds))
        },
        searchInternally() {
            const search = this.keyword;
            this.mutableOptions = this.options.
            filter(
                o => o[this.textKey].toLowerCase().
                normalize('NFD').replace(/[\u0300-\u036f]/g, '').
                search(
                    search.toLowerCase().
                    normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                ) >= 0
            )
        },
        cloneOptions() {
            this.mutableOptions = JSON.parse(JSON.stringify(this.options))
        },
        onSelect(){
            const selected = this.mutableOptions[this.arrowCounter];
            const selectedOption = this.options.find(
                o => o[this.valueKey] === selected[this.valueKey]
            )
            if(this.selecteds[selectedOption[this.valueKey]]){
                this.$delete(
                    this.selecteds, 
                    selectedOption[this.valueKey]
                )
            }else{
                if(selectedOption.disabled){
                    return false
                }

                if(this.onlySelectRules.length > 0) {
                   this.onlySelectRules.map((item) => {
                        if(selectedOption[this.valueKey] == item.option1) {
                            this.$delete(
                                this.selecteds,
                                item.option2
                            )
                        } else if (selectedOption[this.valueKey] == item.option2) {
                            this.$delete(
                                this.selecteds,
                                item.option1
                            )
                        }
                    })
                }

                this.$set(
                    this.selecteds, 
                    selectedOption[this.valueKey], 
                    selectedOption
                )
                
            }
            if(
                Object.keys(this.selecteds).length > 1 &&
                Object.keys(this.selecteds).length == this.countValidOptions() &&
                this.enableSelectionAll
            ){
                this.onSelectAll()
            }else{
                this.emitInput()
            }
        },
        onSelectAll(){
            this.selecteds = {}
            this.keyword = ''
            this.mutableOptions = this.options
            this.$refs.dropdown.hide(true)
            this.emitInput()
        },
        countValidOptions(){
            let i = 0
            this.options.map(option => {
                if(!option.disabled){
                    i++
                }
            })
            return i
        },
        onBlur(){
            this.$refs.dropdown.hide(true)
        },
        setArrowCounter(number) {
            this.arrowCounter = number;
        },
        onArrowUp(){
            if(this.arrowCounter > 0){
                this.arrowCounter -= 1
                this.fixScrolling()
            }
        },
        onArrowDown(){
            if (this.arrowCounter < this.mutableOptions.length - 1) {
                this.arrowCounter += 1
                this.fixScrolling()
            }
        },
        fixScrolling(){
            this.$refs['option_' + this.arrowCounter][0].scrollIntoView(
                {
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'start'
                }
            )
        },
    },
}
</script>
<style>
    .multiselect{
        width: 100%;
    }
    .multiselect .dropdown-menu{
        max-height: 300px;
        overflow: auto;
        transform: translate3d(0px, 38px, 0px) !important;
    }
    .multiselect .dropdown-toggle{
        display: block;
        text-align: left;
        width: 100%;
        height: calc(1.5em + .75rem + 2px);
        padding: .375rem .75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: .25rem;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
        box-shadow: none !important;
    }
    .multiselect .dropdown-toggle::after{
        position: absolute;
        top: 15px;
        right: 10px;
    }
    .multiselect .dropdown-toggle, 
    .multiselect .dropdown-toggle:active,
    .multiselect .dropdown-toggle.active,
    .multiselect .dropdown-toggle:hover, 
    .multiselect .dropdown-toggle.hover {
        background-color: #fff !important;
    }
    .multiselect .dropdown-toggle div{
        width: 90%;
        overflow: hidden;
    }
    .multiselect .dropdown-menu .btn-default{
        background-color: #fff !important;
    }
    .multiselect ul{
        width: 100%;
    }
    .multiselect ul li{
        position: relative;
    }
    .multiselect ul li.selected a:after {
        font-family: Glyphicons Halflings;
        content: "\e013";
        position: absolute;
        right: 10px;
    }
    .multiselect ul li.active a:not(.disabled){
        color: #fff;
    }
    .multiselect ul li > a.disabled{
        color: #6c757d !important;
        background-color: #fff !important;
    }
</style>